/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 29/10/2021
 */

import {JournalEntryType} from "@shared/Journal/JournalEntryType";
import {SessionPlanJournalEntry} from "./journalEntry-imports";
import {createDefaultBTSessionPlanItems} from "@shared/Journal/SessionPlanDefaultItems";

//BehaviorTreeSessionPlanJournalEntry
export default class BTSessionPlanJournalEntry extends SessionPlanJournalEntry {


	constructor({tools, materials, ...options} = {}) {
		super({type: JournalEntryType.BEHAVIOUR_TREE_SESSION_PLAN, ...options});
		if(!this.items || this.items.length === 0){
			this.setupDefaultSessionPlan({tools, materials})
		}
	}

	setupDefaultSessionPlan(options){
		this.items = createDefaultBTSessionPlanItems(options)
		this.recalculateItemSortIndexes()
	}

	getNotesString() {
		return this.getItemArray()
			.filter(item => ["Leaves", "Roots"].includes(item.title))
			.map(item => item.content)
			.filter(item => !!item)
			.join("<br/><br/>")
	}

}
